{
  "de": {
    "inspiration_list": {
      "actions": {
        "cancel": "Rückgängig machen",
        "delete": "Löschen",
        "deleteMultiple": "Löschen …",
        "delete_cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "new": "Neues Fotoalbum",
        "save": "Speichern",
        "submit": "Absenden",
        "tickBoxesDeletion": "Aktivieren Sie die Kontrollkästchen der Dateien, die Sie löschen möchten."
      },
      "attributes": {
        "name": "Name"
      },
      "info": "Was gefällt Ihnen an Ihrem neuen Zuhause? Laden Sie Fotos hoch, die Sie inspirieren! Mit Alben können Sie sie nach Themen ordnen: Küche, Badezimmer, Möbel …",
      "labels": {
        "inspiration_list": "Inspirationslisten",
        "inspirationlist": "Inspirationsalbum",
        "inspirations": "Inspirationen",
        "noInspirationLists": "Noch keine Inspirationsliste",
        "noInspirations": "Noch keine Inspirationen"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Erstellen Sie verschiedene Alben für Küche, Badezimmer oder Möbel und laden Sie Fotos hoch, die Sie inspirieren.",
            "title": "Wie werden Sie Ihr neues Zuhause einrichten?"
          }
        }
      },
      "validation": {
        "needTitle": "Titel ist erforderlich",
        "selectInspirationList": "Wählen Sie mindestens 1 Inspirationsliste aus"
      }
    }
  }
}
